import React, { useState } from 'react';
import { Box, Typography, Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close'; 
 
const EditAboutInfo = ({ className, font16in14, memberData }) => {
  

  return (
    <>
     <Box className={className} sx={{ backgroundColor: '#FFFFFF', padding: {xs:'16px 16px', lg:'16px 20px'}, borderRadius: 2, my: {xs:'10px', lg:'0px'} }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography
          className="FontIvypresto"
          fontWeight={600}
          sx={{
            fontSize: { xs: '20px', xl: '20px' },
            color: '#6A513E',
          }}
        >
          About Me
        </Typography>  
      </Box>

      <Box mt={2} className={font16in14}>
        <Typography sx={{ fontSize: { xs: '12px', sm: '14px', xl: '14px' }, color: '#3C4043', fontWeight: '400', mb:1.5, }}>
            {memberData?.aboutUsDescription}
          </Typography> 
      </Box>
</Box>
      
    </>
  );
};

export default EditAboutInfo;
